module.exports = __webpack_public_path__ + "img/send.e8ab208c.svg";